<template>
  <v-overlay :value="_value" z-index="99999">
    <v-progress-circular
      :color="color"
      :size="size"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: "LoaderOverlay",

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    size: {
      type: [String, Number],
      default: "64",
    },

    color: {
      type: String,
      default: "white",
    },
  },

  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
